import React from "react";
import RecommendationWidget from "./RecommendationWidget";

const RecommendationWidgetWrapper = (props) => <RecommendationWidget {...props} />;

RecommendationWidgetWrapper.displayName = "RecommendationWidgetWrapper";

export default RecommendationWidgetWrapper;
